var AbstractDataModel = require("./AbstractDataModel")
var AbstractWS = require("../ws/AbstractWS");
var TicketsWS = require("../ws/TicketsWS");
var SpotsWS = require("../ws/SpotsWS");
var RedeemWS = require("../ws/RedeemWS");
var NextForecastWS = require("../ws/NextForecastWS");
var IssueWS = require("../ws/IssueWS");
var ExpiredTicketsWS = require("../ws/ExpiredTicketsWS");
var ClearWS = require("../ws/ClearWS");
var TransactionTypeModel = require("./TransactionTypeModel");
var getQueryParam = require("../helpers/viewmodels").getQueryParam
var findInArrays = require("../helpers/polyfill").findInArrays

function QueueModel(obj, messageStore, userLanguage) {
  var self = this;
  var stts = null;
  var tts = null;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractDataModel.apply(self, arguments);

  self.init = self.init.bind(this);
  self.confirmToggleStateFromUI = self.confirmToggleStateFromUI.bind(this);
  self.hasTransactionTypes = self.hasTransactionTypes.bind(this);
  self.issueTicket = self.issueTicket.bind(this);
  self.lastUpdateTimestamp = 0;

  self.id = -1;
  self.serviceTransactionTypes = [];
  self.transactionTypes = [];
  self.supportsCallAhead = false;
  this.isIssuingTicket = ko.observable(false)

  // If data was passed in, initialize the object
  if (obj) {
    // The JSON contains all we need
    self = Object.assign(self, obj);

    if (getQueryParam('debug') === 'true') {
      self.data = obj;
    }

    self.alwaysOverrideForecast = (obj.useLastSpotOverrideForecastAsNext === true);

    // Clean-up the name
    self.name = (obj.name) ? obj.name.toString().trim().replace(/\_/g, ' ') : '';

    // Set a default for privatePhoneDigitCount
    self.privatePhoneDigitCount = obj.privatePhoneDigitCount || 4;

    // State must be an observable
    self.state = ko.observable(obj.state);

    // Waiting for Interest parameter
    self.waitingForInterest = ko.observable(obj.waitingForInterest && obj.waitingForInterest === true);

    // Find transaction types
    tts = Array.makeArray(obj.transactionType);
    if (tts && tts.length > 0) {
      tts.forEach(function (tt) {
        if (!tt.deleted) {
          self.transactionTypes.push(new TransactionTypeModel(tt));
        }
      });
    }

    // Find service transaction types
    stts = Array.makeArray(obj.serviceTransactionType);
    if (stts && stts.length > 0) {
      stts.forEach(function (tt) {
        self.serviceTransactionTypes.push(new TransactionTypeModel(tt));
      });
    }

    // Next Queue Ids
    self.nextQueueIds = Array.makeArray(obj.nextQueueId);

    // Predecessor Queue Ids
    self.predecessorQueueIds = Array.makeArray(obj.predecessorQueueId);

    // Successor Queue Ids
    self.successorQueueIds = Array.makeArray(obj.successorQueueId);

    self.supportsCallAhead = (obj.supportsCallAhead || self.successorQueueIds.length > 0);


    // Find service results
    self.serviceResults = Array.makeArray(obj.serviceResult);
  }

  // API service transactors
  self.clearWS = new ClearWS(self);
  self.expiredTicketsWS = new ExpiredTicketsWS(self, userLanguage);
  self.issueWS = new IssueWS(self);
  self.nextForecastWS = new NextForecastWS(self);
  self.redeemWS = new RedeemWS(self);
  self.spotsWS = new SpotsWS(self, userLanguage);
  self.ticketsWS = new TicketsWS(self, userLanguage);

  // Object which set's the queue state
  self.queueStateProxy = new AbstractWS();
  self.queueStateProxy.name = 'QueueStateProxy-' + self.id;
  self.queueStateProxy.method('POST');


  self.expiredTickets = self.dependentObservable('spots', self.expiredTicketsWS);
  self.nextWaitDuration = self.dependentObservable('duration', self.nextForecastWS);
  self.nextWaitUnits = self.dependentObservable('units', self.nextForecastWS);

  self.serviceCustomer = ko.observable(null);


  /**
   * Gets requested message override for current queue
   *
   * @param {String} message
   * @returns none
   */
  self.getMessageForQueue = function (message) {
    if (messageStore && message) {
      return messageStore(message);
    } else {
      function noMessageStore() { return '' }
    }
  }

	self.handleArrivedClick = function(data, evt) {
    vm.redeemTicket(self, data);
  }

  self.spots = ko.deferredComputed(self._spots.bind(self));
  self.tickets = ko.deferredComputed(self._tickets.bind(self));
  self.canClear = ko.deferredComputed(self._canClear.bind(self));
  self.canSummon = ko.deferredComputed(self._canSummon.bind(self));
  self.cssClass = ko.deferredComputed(self._cssClass.bind(self));
  self.numWaiting = ko.deferredComputed(self._numWaiting.bind(self));
  self.toggleStateMessage = ko.deferredComputed(self._toggleStateMessage.bind(self));
  self.waitTime = ko.deferredComputed(self._waitTime.bind(self));

  // Create a random initialization time so that the render pipeline
  // is not throttled
  var rand = Math.floor(Math.random() * Math.floor(10));
  setTimeout(self.init, rand * 100);
  
  /**
   * 
   * @returns {boolean}
   */
  this.hasMultipleTransactionTypes = function () {
    return self.transactionTypes ? self.transactionTypes.length > 1 : false;
  }

  /**
   * 
   * @returns {boolean}
   */
  this.hasSingleTransactionType = function () {
    return self.transactionTypes ? self.transactionTypes.length == 1 : false;
  }

  /**
   * If a Queue only has a Single Transaction Type, it is the "default" Transaction Type 
   * (because it's the only option to select)
   * 
   * @returns {TransactionTypeModel}
   */
  this.defaultTransactionType = function () {
    return (self.hasSingleTransactionType()) ? self.transactionTypes[0] : null
  }

  this.isSummonButtonDisabled = ko.deferredComputed(function () {
    return this.isIssuingTicket()
  }, this)

  return self;
}

QueueModel.prototype = Object.create(AbstractDataModel.prototype);
QueueModel.prototype.constructor = QueueModel;

QueueModel.prototype.isActive = function () { return (this.state().toLowerCase() === "active") } ;
QueueModel.prototype.isClosing = function () { return (this.state().toLowerCase() === "closing") } ;
QueueModel.prototype.isClosed = function () { return (this.state().toLowerCase() === "closed") } ;
QueueModel.prototype.isInactive = function () { return (this.state().toLowerCase() === "inactive") };


/**
 * Checks if Queue is using Service Results and if there are any configured transaction types
 * that can be used to record the service results
 * @returns {Boolean}
 */
QueueModel.prototype.canApplyServiceResults = function () {
  return this.serviceResults.length > 0 && (this.transactionTypes.length > 0 || this.serviceTransactionTypes.length > 0)
};


/**
 * Removes all waiting consumers from the line
 *
 * @returns {Boolean} true
 */
QueueModel.prototype.clear = function () {
  if (this.spots().length > 0) {
    this.clearWS.doRequest();
  }
  return true;
};


/**
 * Called when a new Consumer joins the line
 *
 * @param {String} sSessionId
 * @returns none
 */
QueueModel.prototype.enter = function (sSessionId) {
  var self = this;
  self.updateAllSpots();
  if (self.audibleAlertsOnEnter) {
    vm.playDoorbellForQueue(self.id);
  }
};

/**
 * Gets expired tickets data
 *
 * @returns none
 */
QueueModel.prototype.getExpiredTickets = function () {
  this.expiredTicketsWS.doRequest();
};


/**
 * Gets the next wait forecast
 *
 * @returns none
 */
QueueModel.prototype.getNextWaitForecast = function () {
  this.nextForecastWS.doRequest();
};


/**
 * Locates a SpotModel by it's session id
 *
 * @param {String} sessionId
 * @returns {SpotModel | null}
 */
QueueModel.prototype.getSpotBySessionId = function (sessionId) {
  var self = this;

  var foundSpot = findInArrays(
    function (spot) {
      return spot.sessionId == sessionId;
    },
    [self.spots(), self.tickets(), self.expiredTickets()]
  );

  // If a Spot has not been found, return null to stay consistent with existing code.
  return foundSpot !== undefined ? foundSpot : null;
};


/**
 * Gets waiting Consumer data
 *
 * @returns none
 */
QueueModel.prototype.getSpots = function () {
  this.spotsWS.doRequest();
};


/**
 * Retrieves summoned Consumer data
 *
 * @returns none
 */
QueueModel.prototype.getTickets = function () {
  this.ticketsWS.doRequest();
};


/**
 * Retuns an index and spot model of consumers waiting. Used
 * in the method to determine if the consumer is being summoned
 * out of order
 *
 * @param {String} sSessionId
 * @returns {Object | Null}
 */
QueueModel.prototype.getWaitingSpotBySessionId = function (sSessionId) {
  var idx = -1;
  var spot = this.spots().find(function (s, i) {
    if (s.sessionId === sSessionId) {
      idx = i;
    }

    return s.sessionId === sSessionId;
  });

  return { idx: idx, spot: spot } || null;
}


/**
 * Initializes the QueueModel by pulling in disparate Spot data
 *
 * @returns none
 */
QueueModel.prototype.init = function () {
  var self = this;
  // Exposed members from API call returns
  self.spots = self.dependentObservable('spots', self.spotsWS);
  self.tickets = self.dependentObservable('tickets', self.ticketsWS);
  // Initialize the spots and time forecast, since these will be
  // displayed in the queue list
  self.updateAllSpots();
  self.getNextWaitForecast();
};


/**
 * Calls the next available Consumer to be served
 *
 * @returns none
 */
QueueModel.prototype.issueTicket = function () {
  var self = this;
  self.issueWS.deleteParam('maxPartySize');
  this.preIssueTicket();
  self.issueWS.doRequest(null, null, this.postIssueTicket.bind(this));
};


/**
 * Calls a method on the SpotsWS to remove a spot by session Id
 *
 * @param {String} sSessionId
 * @returns none
 */
QueueModel.prototype.leave = function (sSessionId) {
  var self = this;
  vm.conlog('LEAVE - ' + sSessionId);
  self.spotsWS.removeSpot(sSessionId);
  self.getTickets();
};


/**
 * Method to move a spot back in the Queue ( or another queue)
 *
 * @param {String} sSessionId
 * @param [QueueModel] Optional destination queue
 * @returns none
 */
QueueModel.prototype.pushBack = function (sSessionId, oDestQueue) {
  var self = this;
  var expiredTicket = self.expiredTicketsWS.getSpotBySessionId(sSessionId);
  var spot = self.spotsWS.getSpotBySessionId(sSessionId);
  var ticket = self.ticketsWS.getTicketBySessionId(sSessionId);

  if (spot) {
    if (oDestQueue && oDestQueue.audibleAlertsOnEnter) {
      // canvas.playDoorbell();
    }

    vm.conlog('Found spot');
    self.updateAllSpots();
    return;
  }

  if (ticket) {
    self.getTickets();
    self.enter(sSessionId);
    vm.conlog('Found ticket');
    return;
  }

  if (expiredTicket) {
    self.expiredTicketsWS.doRequest();
    self.enter(sSessionId);
    vm.conlog('Found expired ticket');
    return;
  }
};


/**
 * Summons the next waiting customer in line
 *
 * @returns none
 */
QueueModel.prototype.summonCustomer = function () {
  var self = this;
  var classifierVisible = false;
  var loc = null;
  var ticketBasedOnPartySize = false;

  if (self.spots().length === 0) {
    return;
  }

  if (self.spots().length === 1) {
    var foundConsumer = vm.currentlyServicing().find( function (spot) {
      return spot.sessionId === self.spots()[0].sessionId;
    });

    if (foundConsumer) {
      this.issueTicket();
      setTimeout(function () {self.getSpots()}, 100);
      return;
    }
  }

  // get the location for this queue
  loc = vm.locationsWS.getLocationById(self.locationId);

  /// TODO - extend this to support more than one selected location
  // If we need a station to summon a customer and one hasn't been chosen,
  // show that interface first
  var employeeMustSelectClassifier = loc.supportsStationMetadata() === false || vm.checkStationWS.browserGUID() === null
  if (employeeMustSelectClassifier && loc.ticketClassifiers.length > 0) {
    vm.settingsShow(self.issueTicket);
    return;
  }

  classifierVisible = vm.showClassifierOnSummon(self);
  ticketBasedOnPartySize = self.ticketBasedOnPartySize;

  self.issueTicket();

  return false;
};


/**
 * Sends an API request to enable/disable a queue
 *
 * @param {String} sAction
 * @returns none
 */
QueueModel.prototype.toggleState = function (sAction) {
  var self = this;
  var action = (self.state() != 'ACTIVE') ? 'start' : 'stop';

  if (typeof sAction === 'string' && ['stop', 'start'].indexOf(sAction.toLowerCase()) > -1) {
    action = sAction.toLowerCase();
  }

  self.queueStateProxy.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/queues/' + self.id + '/' + action;
  });

  self.queueStateProxy.doRequest();
};


/**
 * Prompt the User (Employee) to confirm before toggling to the
 * Inactive state if the Queue is active.
 */
QueueModel.prototype.confirmToggleStateFromUI = function(action) {
  var self = this;
  if (self.isActive()) {
    var confirmation = window.confirm("Are you sure you want to deactivate the queue?")
    if (confirmation) {
      self.toggleState(action)
    }
  } else {
    self.toggleState(action)
  }
};


/**
 * Updates data needed to furnish information to the queue list
 *
 * @return none
 */
QueueModel.prototype.updateSidebar = function () {
  var self = this;
  self.spotsWS.doRequest();
  self.ticketsWS.doRequest();
  self.nextForecastWS.doRequest();
};


/**
 * Delegates to API services to retrieve new data
 *
 * @returns none
 */
QueueModel.prototype.updateAllSpots = function () {
  var self = this;
  if (self.id != -1) {
    self.getExpiredTickets();
    self.getNextWaitForecast();
    self.getSpots();
    self.getTickets();
    self.stampLastUpdate();
  }
};


/**
 * Calls all spots to update their own variances
 *
 * @returns none
 */
QueueModel.prototype.updateVariances = function () {
  var self = this;
  if (self.state() !== 'INACTIVE') {
    self.spots().forEach(function (spot) {
      spot.updateVariance();
    });
  }
};


QueueModel.prototype.hasTransactionTypes = function () {
  return this.transactionTypes ? this.transactionTypes.length > 0 : false;
};

/**
 *
 * @returns {Array}
 */
QueueModel.prototype._spots = function () {
  var self = this;
  if (self.spotsWS) {
    return self.spotsWS.spots();
  }
  return [];
};

/**
 *
 * @returns {Array}
 */
QueueModel.prototype._tickets = function () {
  var self = this;
  if (self.ticketsWS) {
    return self.ticketsWS.tickets();
  }
  return [];
};


/**
 * Determines if a user can clear the waiting spots in a queue
 *
 * @returns {Boolean}
 */
QueueModel.prototype._canClear = function () {
  var self = this;
  return self.spots().length > 0 && vm.hasRole('queueAdmin.' + self.id) && self.clearEnabled;
};


/**
 * Determines whether or not consumers can be summoned from this queue
 *
 * @return {Boolean}
 */
QueueModel.prototype._canSummon = function () {
  var self = this;
  if (self.spots) {
    return self.spots().filter(function (spot) {
      return !spot.callAhead;
    }).length > 0;
  }

  return false;
};


/**
 * Returns a list of CSS decorations which can be applied to this queue
 *
 * @return {String}
 */
QueueModel.prototype._cssClass = function () {
  var self = this;
  var aClasses = [];

  aClasses.push('queue-title-' + self.state().toLowerCase());

  if (self.state() === 'ACTIVE' && self.waitingForInterest() && self.nextWaitDuration() === -1) {
    aClasses.push('queue-title-waiting');
  }

  if (vm && vm.selectedQueueIds.indexOf(self.id) > -1) {
    aClasses.push('queue-selected');
  }

  return aClasses.join(' ');
};


/**
 * Observable to show number of consumers actively waiting in line
 *
 * @returns {Number}
 */
QueueModel.prototype._numWaiting = function () {
  var self = this;
  var spots = (self.spots) ? self.spots() || [] : [];
  var tickets = (self.tickets) ? self.tickets() || [] : [];

  return spots.length + tickets.length;
};


/**
 * Message to present regarding the button action of a queue
 *
 * @returns {String}
 */
QueueModel.prototype._toggleStateMessage = function () {
  var token = (this.state() === 'ACTIVE') ? 'deactivate' : 'activate';
  return vm.messagesWS.get(token) + ' ' + vm.messagesWS.get('queue');
};


/**
 * Provides a message to show the current wait time for a queue, or it's
 * state if not active
 *
 * @returns {String}
 */
QueueModel.prototype._waitTime = function () {
  var self = this;
  if (self.state() != 'ACTIVE') {
    return vm.messagesWS.get(self.state().toLowerCase());
  }
  else {
    if (self.nextWaitDuration) {
      if (self.nextWaitDuration() === -1) {
        return vm.messagesWS.get('waiting.to.begin');
      }
      else {
        return vm.formatWaitTime(self.nextWaitDuration(), self.nextWaitUnits())
      }
    }

    return '';
  }
};

/**
 * Mark the time the Queue's Spot data was last updated.
 */
QueueModel.prototype.stampLastUpdate = function() {
  this.lastUpdateTimestamp = Date.now()
}

/**
 * @return {number} elapsed time in seconds
 */
QueueModel.prototype.timeSinceLastUpdate = function() {
  return (Date.now() - this.lastUpdateTimestamp) / 1000;
}

QueueModel.prototype.hasServiceTransactionTypes = function () {
  return this.serviceTransactionTypes.length >= 1
}

/**
 * Default Country Code
 * @returns {number|null}
 */
QueueModel.prototype.defaultPhoneCountryCode = function () {
  var location = vm.locationsWS.getLocationById(this.locationId)
  var code = (location && location.defaultPhoneCountryCode) ? location.defaultPhoneCountryCode : null
  return code
}

QueueModel.prototype.preIssueTicket = function () {
  this.isIssuingTicket(true)
}

QueueModel.prototype.postIssueTicket = function () {
  this.isIssuingTicket(false)
}

QueueModel.prototype.testId = function () {
  return "queue-" + this.id 
}

QueueModel.prototype.summonButtonTestId = function () {
  return "queue-summon-button-" + this.id
}

QueueModel.prototype.hasNextQueues = function() {
  return Array.isArray(this.nextQueueIds) && this.nextQueueIds.length > 0
}


if (typeof exports !== 'undefined') {
module.exports = QueueModel;
}
